import { Types } from "../actions/actionTypes";
import { getUser, clearUser } from "../../services/storage/user";
const initialState = {
  isLoggedIn: false,
  user: null,
  token: null,
  message: "",
};
const userData = getUser() ?? initialState;

const user = (state = userData, action) => {
  const { type, payload } = action;
  switch (type) {
    case Types.SET_USER_DATA:
      return {
        ...payload,
        isLoggedIn: true,
      };
    case Types.CLEAR_USER_DATA:
      clearUser();
      return {
        isLoggedIn: false,
        user: null,
        token: null,
        message: "",
      };
    default:
      return state;
  }
};

export default user;
